import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { PreferenceService } from '../../../services/preference.service';
import { TreeNode } from 'primeng/api';

@Component({
  standalone: false,
  selector: 'app-license-used-detail',
  templateUrl: './license-used-detail.component.html',
  styleUrls: ['./license-used-detail.component.css']
})
export class LicenseUsedDetailComponent implements OnInit {
  licenseUsedDetailTable_cols: any[] = [
    { field: 'Company', header: 'Company', width: '220', class: 'col-nowrap' },
    { field: 'UsedLicense', header: 'Used License (Max)', width: '220', class: 'col-nowrap' },
  ];
  licenseUsedDetailList = [];
  datePickStart: Date;
  licenseUsageList: TreeNode[];
  constructor( private _location: Location, public preferenceService: PreferenceService ) {
    this.getDefaultDate();
    this.licenseUsageList = [
      {
        data: {
          name: 'SHI MSP',
          quantity: 600,
          unitprice: 2.5,
          amount: 1500,
        },
        expanded: true,
        children: [
          {
            data: {
              name: 'Aspen Dental',
              quantity: 400,
              unitprice: 2.5,
              amount: 1000,
            },
            expanded: true,
            children: [
              {
                data: {
                  name: 'Aspen 1',
                  quantity: 200,
                  unitprice: 2.5,
                  amount: 500,
                },
              },
              {
                data: {
                  name: 'Aspen 2',
                  quantity: 200,
                  unitprice: 2.5,
                  amount: 500,
                },
              },
            ],
          },
          {
            data: {
              name: 'SHI 1',
              quantity: 100,
              unitprice: 2.5,
              amount: 250,
            },
          },
          {
            data: {
              name: 'SHI 2',
              quantity: 100,
              unitprice: 2.5,
              amount: 250,
            },
          },
        ],
      },
    ];
  }

  ngOnInit() {
  }


  backClicked() {
    this._location.back();
  }

  getDefaultDate() {
    const today = new Date();
    const preDate = new Date(today);
    this.datePickStart = preDate;
  }
}
